import styled from 'styled-components'
import { Trigger } from '@radix-ui/react-dropdown-menu'

export const DropdownTrigger = styled(Trigger)`
  svg {
    color: ${({ theme }) => theme.colors.white0};
  }
`
export const LanguageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  color: white;
  padding-top: 40px;
  padding-right: 38px;
`
export const LanguageIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  color: white;
  padding-right: 8px;
`
